import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-wishlist"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M29.5,31.5l-7-5l-7,5v-16c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2V31.5z",
      class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
    }, null, -1)
  ]), 16))
}
export default { render: render }